import { useState, useCallback } from "react";
import { CommonType, DeviceDto } from "../../types";
import { getParserConfigList } from "../../services/parserConfigService";
import { getDevicePaginate } from "../../services/deviceService";
import { usePaginatedData } from "../../hooks/usePaginatedData";
import { fetchListOrThrow } from "../../utils/fetchList";

export const useDeviceData = (deviceTypeId?: number) => {
  const [parserConfig, setParserConfig] = useState<CommonType[]>([]);

  const fetchFn = useCallback(
    (page: number, pageSize: number, filter: string) =>
      getDevicePaginate({ page, pageSize, filter, ...(deviceTypeId !== undefined && { deviceTypeId }) }),
    [deviceTypeId]
  );

  const paginated = usePaginatedData<DeviceDto>(fetchFn, [deviceTypeId]);

  const fetchParserConfig = () => fetchListOrThrow(getParserConfigList, setParserConfig);

  return { ...paginated, parserConfig, fetchParserConfig };
};
